import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Spin, Divider, Steps, Button, Icon, Card, Tooltip, Modal, Progress } from "antd";
import { IPagination } from "src/common/types";
import { ApplicationState } from "src/store";
import { PayListType, LoadingType, PayType, ExportType } from "src/store/pay/types";
import {
  fetchPayList,
  fetchOnePayFinish,
  fetchTempUrl,
  fetchApplyPay,
  fetchStatusList,
  fetchCommon,
  fetchQueryImage,
  fetchLoading,
  fetchExportExcel,
  fetchExportByTaskId
} from "src/store/pay/actions";
import MsTable from "src/components/ms-common/ms-table/MsTable";
import MsSearchPay from "./ms-search-pay/MsSearchPay";
import MsNewPay from "./ms-new-pay/MsNewPay";
import MsModalPay from "./ms-modal-pay/MsModalPay";
import Tools from "src/utils/tools";
import "./MsPayList.scss";

interface PropsFromState {
  payList: PayListType[];
  pagination: IPagination;
  loading: LoadingType;
  onePay: PayType;
  exportExcel: ExportType;
}

interface PropsFromDispatch {
  searchDisp: typeof fetchPayList;
  setOnePayDisp: typeof fetchOnePayFinish;
  getTempUrlDisp: typeof fetchTempUrl;
  applyDisp: typeof fetchApplyPay;
  statusDisp: typeof fetchStatusList;
  commonDisp: typeof fetchCommon;
  imageDisp: typeof fetchQueryImage;
  loadingDisp: typeof fetchLoading;
  exportDisp: typeof fetchExportExcel;
  stopExportDisp: typeof fetchExportByTaskId;
}

type AllProps = PropsFromState & PropsFromDispatch;

const Step = Steps.Step;

// 关联state到组件props
const mapStateToProps = ({ payState }: ApplicationState) => ({
  loading: payState.loading,
  payList: payState.payList,
  pagination: payState.pagination,
  onePay: payState.onePay,
  exportExcel: payState.exportExcel
});

// 关联dispatch到组件props
const mapDispatchToProps = (dispatch: Dispatch) => ({
  searchDisp: (params: any) => dispatch(fetchPayList(params)),
  setOnePayDisp: (params: any) => dispatch(fetchOnePayFinish(params)),
  getTempUrlDisp: (param: any) => dispatch(fetchTempUrl(param)),
  applyDisp: (param: any) => dispatch(fetchApplyPay(param)),
  statusDisp: (param: any) => dispatch(fetchStatusList(param)),
  commonDisp: (param: any) => dispatch(fetchCommon(param)),
  imageDisp: (param: any) => dispatch(fetchQueryImage(param)),
  loadingDisp: (param: any) => dispatch(fetchLoading(param)),
  exportDisp: (param: any) => dispatch(fetchExportExcel(param)),
  stopExportDisp: (param: any) => dispatch(fetchExportByTaskId(param))
});

const stepList = [
  {id: 1, title: "创建发放", description: "上传需发放员工名单,微知认证名单"},
  {id: 2, title: "确认发放", description: "核对并确认需发放的员工名单"},
  {id: 3, title: "支付发放款项", description: "支付发放金额，等待发放"},
  {id: 4, title: "发放完成", description: "如有失败则提交正确信息后再次发送"},
];

class MsPayList extends React.Component<AllProps> {

  public modalType: string = ""; // 弹窗类型
  public record: any = {};       // 列表单条数据
  public searchForm: any;        // 查询页面的表单
  public searchValue: any;       // 页面跳转时存放的查询内容

  public searchParams = {
    page: 1,
    limit: 10
  };
  /**
   * 重写列表中的一个th内容
   */
  public onTitle = () => (
    <div className="title-div">
      <span>认证结果</span>
      <Tooltip placement="bottomRight" title="认证失败不会发送">
        <Icon type="info-circle" />
      </Tooltip>
    </div>
  );
  /**
   * 页面初始化加载
   */
  public componentDidMount() {
    this.props.statusDisp({channelId: this.props.onePay.channelId});
    this.onSearch(this.searchParams);

  }

  // 勿删，调试用 public componentDidUpdate = () => {
  //   const dom: any = document.getElementById("r-0");
  //   console.log("完毕",dom);
  //   const str = dom.innerHTML;
  //   const h = dom.offsetHeight;
  //   console.log(str, "上层高度", h, "自己的", dom.style.height);
  //     for (let i = 0; i < str.length; i++) {
  //       dom.innerHTML = str.substr(0, i);
  //       console.log("上层的高度：==", dom.offsetHeight);
  //       if (dom.offsetHeight > 65) {
  //         dom.innerHTML = str.substr(0, i - 3) + '...';
  //         break;
  //       }
  //       // if (dom.style.height > h) {
  //       //   dom.style.overflow = 'hidden';
  //       //   text = str.substr(0, i - 3) + '...';
  //       //   break;
  //       // }
  //     }
  //     // const dom1: any = document.getElementsByClassName("ant-table-row-level-0");
  //     // console.log(dom1, this.props.payList.length);
  //     // for (let i = 10; i < dom1.length; i++) {
  //     //   console.log(dom1[i]);
  //     //   dom1[i].className="div-height";
  //     // }
  // }

  /**
   * 查询列表
   * @param  params  参数
   */
  public onSearch = (params: any) => {
    const { channelId } = this.props.onePay;
    this.searchParams = {
      ...this.searchParams,
      ...params,
      channelId,
    };
    this.props.searchDisp(this.searchParams);
  }
  /**
   * 子组件的查询按钮
   * @param   obj   子组件返回的查询条件对象
   */
  public onSearchList = (obj: object) => {
    this.searchParams.page = 1;
    this.onSearch(obj);
  }
  /**
   * 点击分页
   * @param  pages     当前页
   * @param  pageSize  每页条数
   */
  public onChangePage = (pages: any, pageSize: any) => {
    this.onSearch({ ...this.searchParams, page: pages, limit: pageSize });
  }
  /**
   * 进入创建发放页面并查询当前用户是否有模板
   */
  public onCreateNew = () => {
    this.searchValue = this.searchForm.getFieldsValue();
    this.props.getTempUrlDisp({bizLine: 1});
  }
  /**
   * 返回列表页面
   */
  public onGoBack = () => {
    this.props.setOnePayDisp({isShowNew: false});
  }
  /**
   * 关闭弹窗
   */
  public onCloseModal = () => {
    this.props.setOnePayDisp({isShowModal: false});
  }
  /**
   * 保存弹窗中返回的数据
   * @param   data   数据对象
   * @param   type   弹窗类型
   */
  public onSavePayFromModal = (data: any, type: string) => {
    if (type === "apply" || type === "adjust") {
      this.props.applyDisp({data, searchParams: this.searchParams, type});
      return;
    }
    this.props.commonDisp({data, searchParams: this.searchParams, type});
  }
  /**
   * 创建发放页面点击创建时返回的数据，在弹窗中进行二次确认
   * @param   data   创建发放页面返回的数据
   */
  public onSave = (data: any) => {
    this.modalType = "apply";
    this.record = data;
    this.props.setOnePayDisp({isShowModal: true, fileName: "", imageList: []});
  }

  /**
   * 备注和拒绝原因要提示语
   * 当备注超长且出现在版边时注意：
   * 设置autoAdjustOverflow为true时，宽度不会自动调整
   * 如果设为false，宽度会自动调整，但是鼠标首次移上去时antd的计算有误，出现位置会有错误。
   * 所以暂时通过prefixCls改变原始class来重新设置样式。
   * 当设置了prefixCls时，autoAdjustOverflow必须设为false
   * @param    type    类型：remark:备注，reject:拒绝原因
   * @param    text    内容
   * @param    record  单条数据
   * @param    index   索引
   */
  public onHandleRemark = (type: string) => {
    return (text: string, record: any, index: number) => {
      const str = `${type}-tip-${index}`;
      return (
        <div className="remark-div">
          <Tooltip
            placement="topLeft"
            overlayClassName={str}
            title={text}
            autoAdjustOverflow={false}
            prefixCls={`remake`}
          >
            <span id={str} onMouseEnter={this.onRePositionArrow(str)}>{text}</span>
          </Tooltip>
        </div>
      )
    }
  }
  /**
   * 重新调整tooltip的箭头
   * 由于前三列被冻结，当表向右滚动时，备注会被遮挡，此时箭头会出现在冻结列的元素上。
   * 由于antd每次onMouseEnter时会重新覆盖class，所以用定时器不断获取元素，然后添加类元素
   * domSpan: 表中的备注/拒绝原因元素
   * domFixed: 表中冻结区域元素
   * domTip: 提示语元素
   */
  public onRePositionArrow = (id: string) => {
    return () => {
      const domSpan: any = document.getElementById(id);
      const domFixed: any = document.getElementsByClassName("ant-table-fixed-left");
      const spanParam = domSpan.getBoundingClientRect(); // 获取备注距离参数对象
      const spanPosition = Math.floor(spanParam.x);
      const fixedParam = domFixed[0].getBoundingClientRect(); // 获取冻结区域参数对象
      const fiexedPosition = fixedParam.x + fixedParam.width;
      const num = fiexedPosition - spanPosition; // 冻结区域和备注距离的差值

      if (num > 13 && num < 200) {
        let domTip: any = document.getElementsByClassName(id);
        if (!domTip[0]) { // 首次出现前，提示语元素并不存在，需要不断获取，获取元素后添加类
          const t = setInterval(() => {
            domTip = document.getElementsByClassName(id);
            if (domTip[0]) {
              const name = domTip[0].getAttribute("class");
              domTip[0].setAttribute("class", `re-position-${Math.floor(num / 10)} ${name}`);
              clearInterval(t);
            }
          }, 10);
        } else { // 首次出现后，会一直存在body中，并且antd会重新覆盖已存在的类，此时需要再次添加类
          let time = 1;
          const t = setInterval(() => {
            const name = domTip[0].getAttribute("class");
            domTip[0].setAttribute("class", `re-position-${Math.floor(num / 10)} ${name}`);
            if (time === 2) {
              clearInterval(t);
            }
            time++;
          }, 70);
        }
      }
    }
  }
  /**
   * 重写列表中两个td内容
   * @param  total   总数
   * @param  succ    成功
   * @param  fail    失败
   */
  public onShowResult = (total: number, succ: number, fail: number) => (
    <div>总{total}, 成功{succ}, 失败{fail}</div>
  );
  /**
   * 打开弹窗，modalType和record会作为参数给MsModal
   * @param   type     弹窗类型
   * @param   record   单条数据对象
   */
  public onShowModal = (type: string, record: any) => {
    return () => {
      this.modalType = type;
      this.record = record;
      if (type === "query") {
        this.props.imageDisp({batchNo: record.batchNo});
      }
      this.props.setOnePayDisp({isShowModal: true, fileName: "", imageList: []});
    }
  }
  /**
   * 根据列表中的operate字段显示按钮（operate内容为："1,2,5")，查看名单永远在最右边，所以最后添加查看名单
   * @param   record    单条数据
   */
  public onShowButton = (record: any) => {
    const line = <Divider type="vertical" />;
    const fn = this.onShowModal;
    const str = "javascript:;";
    const optArr = {
      1: {opt: "export", name: "查看名单"},
      2: {opt: "cancel", name: "撤销"},
      3: {opt: "confirm", name: "确认发放"},
      4: {opt: "adjust", name: "名单调整"},
      5: {opt: "upload", name: "上传银行凭证"},
      6: {opt: "query", name: "查看银行凭证"}
    };
    const arr = record.operate.split(",");
    let btnDom = [];
    if (arr.length > 1) {
      btnDom = arr.map((ele: any, i: number) => {
        if (i) {
          const one = optArr[+ele];
          return (
            <span key={ele}>
              <a href={str} onClick={fn(one.opt, record)}>{one.name}</a>
              {line}
            </span>
          )
        } else {
          return null;
        }
      });
    }
    btnDom.push(<a href={str} key="1" onClick={this.exportExcel(record)}>{optArr[1].name}</a>);
    return btnDom;
  }
  /**
   * 导出名单
   * @param   record   单条数据
   */
  public exportExcel = (record: any) => {
    return () => {
      this.props.exportDisp({
      batchNo: record.batchNo,
      fileName: record.companyName,
      viewType: 0,
      requestSource: 1
      })
    }
  }
  /**
   * 存放查询页面的form
   */
  public onRef = (form: any) => {
    this.searchForm = form;
  }
  /**
   * 点击取消关闭进度条弹窗
   */
  public onCloseExport = () => {
    this.props.stopExportDisp({stopDownload: true});
  }

  public render() {
    const { pagination, payList, loading, exportExcel, onePay } = this.props;
    const columns = [
      {title: "发放编号", dataIndex: "batchNo", key: "batchNo", align: "left", width: 255, fixed: "left"},
      {title: "发放总额", dataIndex: "checkSalaryAmount", key: "checkSalaryAmount", align: "center", width: 200, fixed: "left", render: (text: string) => (
        <div>￥{Tools.thousandSeparator(text)}</div>
      )},
      {title: "发放笔数", dataIndex: "checkSNum", key: "checkSNum", align: "center", width: 120, fixed: "left"},
      {title: "服务费", dataIndex: "serviceCharge", key: "serviceCharge", align: "center", width: 120, render: (text: string) => (
        <div>￥{Tools.thousandSeparator(text)}</div>
      )},
      {title: "增值附加税", dataIndex: "valueAddedTaxAmount", key: "valueAddedTaxAmount", align: "center", width: 120},
      {title: "应付金额", dataIndex: "shoudPayAmount", key: "shoudPayAmount", align: "center", width: 200, render: (text: string) => (
        <div>￥{Tools.thousandSeparator(text)}</div>
      )},
      {title: "发放备注", dataIndex: "remark", key: "remark", align: "center", width: 220, render: this.onHandleRemark("remark"), className: "remark"},
      {title: this.onTitle, dataIndex: "authResult", key: "authResult", align: "center", width: 250, render: (text: object, record: any) => (
        this.onShowResult(record.checkTotalNum, record.succCheckNum, record.failCheckNum)
      )},
      {title: "发放结果", dataIndex: "payResult", key: "payResult", align: "center", width: 250, render: (text: object, record: any) => (
        this.onShowResult(record.totalNum, record.succNum, record.failNum)
      )},
      {title: "创建时间", dataIndex: "createTime", key: "createTime", align: "center", width: 170},
      {title: "发放时间", dataIndex: "specifyPayDate", key: "specifyPayDate", align: "center", width: 120},
      {title: "状态", dataIndex: "statusDesc", key: "statusDesc", align: "center", width: 130},
      {title: "原因", dataIndex: "rejectRemark", key: "rejectRemark", align: "center", width: 220, render: this.onHandleRemark("reject"), className: "remark"},
      {title: "操作", dataIndex: "opt", key: "opt", align: "right", width: 305, render: (text: any, record: any) =>  (
        <div>
          {this.onShowButton(record)}
        </div>
      )}
    ];

    const pageObj = {
      pageSizeOptions: ["10", "50", "100"],
      onChange: this.onChangePage,
      ...pagination
    };

    const steps = stepList.map((ele: any) => (
      <Step key={ele.id} title={ele.title} description={ele.description} status="process" />
    ));
    return (
      <div className="ms-pay-list">
        <Spin tip={loading.text} className="h-100-p" spinning={loading.showA} size="large">
          {onePay.isShowNew
          ? <MsNewPay
              goBack={this.onGoBack}
              save={this.onSave}
            />
          : <div className="list-main">
              <div className="tip-a">
                <Icon type="info-circle" theme="filled" />
                为保障发放正常，请在发放时间前3个工作日创建完成任务。并在发放时间中午12点之前付款。
              </div>
              <Card className="card-step">
                <div className="title">
                  <span>收入发放</span>
                </div>
                <Steps>{steps}</Steps>
              </Card>
              <Card className="card-list">
                <div className="btn-div">
                  <span className="tip">如有问题请联系我们，客服电话400-820-9911</span>
                  <Button type="primary" onClick={this.onCreateNew}><Icon type="plus" />创建发放</Button>
                </div>
                <MsSearchPay
                  clickSearch={this.onSearchList}
                  onRef={this.onRef}
                  searchValue={this.searchValue}
                />
                <MsTable
                  className="pay-list-table"
                  rowKey="batchNo"
                  dataSource={payList}
                  columns={columns}
                  loading={false}
                  pagination={pageObj}
                  scroll={{x: 2680}}
                  otherHeight={178}
                />
              </Card>
            </div>
          }
          {onePay.isShowModal
          ? <MsModalPay
              type={this.modalType}
              record={this.record}
              closeModal={this.onCloseModal}
              savePay={this.onSavePayFromModal}
            />
          : null
          }
          <Modal
            className="export-excel"
            title="名单下载"
            width={434}
            visible={ exportExcel.showRate }
            closable={false}
            destroyOnClose={true}
            onCancel={this.onCloseExport}
          >
            <Progress status="active" percent={ exportExcel.rate } />
          </Modal>
        </Spin>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MsPayList);


// WEBPACK FOOTER //
// ./src/components/ms-pay/MsPayList.tsx